<template>
  <div class="tag-list" ref="tagListRef">
    <a-tabs
      size="small"
      type="editable-card"
      v-model:activeKey="activePath"
      hide-add
      @edit="onTabEdit"
      @tabClick="onTabClick"
    >
      <a-tab-pane
        v-for="(item, index) in store.state.user.routerTags"
        :key="item.menuPath"
      >
        <template #tab>
          <a-dropdown :trigger="['contextmenu']">
            <span :data-path="item.menuPath" :data-systemid="item.systemId">
              {{
                i18n.global.locale != 'zh-CN' && item.menuNameEn
                  ? item.menuNameEn
                  : item.menuName
              }}
            </span>
            <template #overlay>
              <a-menu @click="k => onRightClick(k, index)">
                <a-menu-item :key="1">关闭右侧</a-menu-item>
                <a-menu-item :key="2">关闭其他</a-menu-item>
                <a-menu-item :key="3">全部关闭</a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </template>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
import {
  onMounted,
  watch,
  inject,
  reactive,
  ref,
  nextTick,
  computed
} from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import { cloneDeep } from 'lodash-es'
import Sortable from 'sortablejs'

import {
  getQueryPath,
  unmountApp,
  unmountAppList,
  reloadApp
} from '../../utils/mfe'

export default {
  setup() {
    const store = useStore()
    const router = useRouter()
    const route = useRoute()
    const searchValue = inject('searchValue')
    const tagListRef = ref(null)
    const state = reactive({
      activeMenuKey: store.state.user.activeMenuKey,
      routerTags: store.state.user.routerTags,
      isTabClickTrigger: false
    })

    const activePath = computed({
      get() {
        const tags = store.state.user.routerTags
        const index = store.state.user.activeMenuKey
        return tags[index]?.menuPath
      },
      set(path) {
        const index = store.state.user.routerTags.findIndex(
          item => item.menuPath === path
        )
        if (index > -1) {
          store.commit('user/setActiveMenuKey', index)
        }
      }
    })

    watch(
      [() => route.fullPath],
      () => {
        const path =
          route.fullPath.indexOf('http') > -1
            ? route.query.target
            : route.fullPath

        const activeIndex = state.routerTags.findIndex(item => {
          return item.menuPath === path
        })
        if (activeIndex > -1) {
          store.commit('user/setActiveMenuKey', activeIndex)
        } else {
          const data = store.state.user.menuList.find(item => {
            return item.menuPath === path
          })
          if (data) {
            store.commit('user/saveHistoryRouter', { data })
          }
        }
      },
      {
        immediate: true
      }
    )
    watch(
      () => store.state.user.activeMenu,
      newVal => {
        openWindow(newVal)
      },
      {
        deep: true
      }
    )
    watch(
      () => store.state.user.activeMenuKey,
      newVal => {
        state.activeMenuKey = newVal
      }
    )
    watch(
      () => store.state.user.routerTags,
      newVal => {
        state.routerTags = newVal
      }
    )

    /**
     * 删除标签
     */
    const onTabEdit = targetKey => {
      const routerTags = store.state.user.routerTags
      const index = routerTags.findIndex(item => item.menuPath === targetKey)
      if (index === -1) return

      const item = routerTags[index]
      unmountApp(item)
      store.commit('user/saveHistoryRouter', { index })
      if (index === state.activeIndex) {
        if (state.activeIndex > 0) {
          openWindow(routerTags[index - 1])
        } else if (store.state.user.routerTags.length) {
          openWindow(routerTags[index])
        } else {
          router.push('/')
        }
      } else if (index < state.activeIndex) {
        store.commit('user/setActiveMenuKey', state.activeIndex - 1)
      }
      state.isTabClickTrigger = true
    }

    const onTabClick = targetKey => {
      const index = store.state.user.routerTags.findIndex(
        item => item.menuPath === targetKey
      )
      if (index > -1) {
        store.commit('user/setActiveMenuKey', index)
      }
      state.isTabClickTrigger = true
    }

    const onRightClick = ({ key }, tabIndex) => {
      const routerTags = cloneDeep(store.state.user.routerTags)
      const newTags = []
      const removeTags = []
      for (let index = 0; index < routerTags.length; index++) {
        const tag = routerTags[index]
        if (
          (key === 1 && index > tabIndex) ||
          (key === 2 && tabIndex !== index) ||
          key === 3
        ) {
          removeTags.push(tag)
        } else {
          newTags.push(tag)
        }
      }
      // 卸载应用
      unmountAppList(removeTags)
      store.commit('user/updateTags', newTags)
      state.isTabClickTrigger = true
      if (key === 1 || key === 2) {
        openWindow(routerTags[newTags.length - 1])
      }
      if (newTags.length === 0) {
        router.push('/')
        store.commit('user/setActiveMenuKey', 0)
      } else if (state.activeMenuKey >= newTags.length) {
        store.commit('user/setActiveMenuKey', newTags.length - 1)
      }
    }
    /**
     * 添加浏览记录
     */
    const openWindow = async item => {
      if (!item) {
        return
      }
      store.commit(
        'app/SET_OTHER_SYSTEM',
        {
          id: +item.systemId,
          name: item.systemName,
          menuName: item.menuName
        },
        {
          root: true
        }
      )
      const menuPath = item.menuPath
      if (menuPath.startsWith('/')) {
        const { path, query } = getQueryPath(menuPath)
        router.push({
          path,
          query
        })
      } else if (menuPath.startsWith('http')) {
        router.push({
          name: 'Iframe',
          query: {
            target: menuPath
          }
        })
      }
      if (!state.isTabClickTrigger) {
        reloadApp(item, true)
      }
      state.isTabClickTrigger = false
    }
    const initBreadTags = () => {
      let { pathname, searchParams, search } = new URL(window.location.href)
      if (pathname === '/Iframe') {
        pathname = searchParams.get('target')
      } else {
        pathname = pathname + search
      }
      const result = store.state.user.menuList.find(item => {
        return item.menuPath === pathname
      })
      store.commit('user/saveHistoryRouter', { data: result })
    }
    const initSortable = () => {
      const el =
        tagListRef.value.querySelector('.portal-ant-tabs-nav-list') ||
        tagListRef.value.querySelector('.ant-tabs-nav-list') ||
        tagListRef.value.querySelector('.portal-ant-tabs-nav') ||
        tagListRef.value.querySelector('.ant-tabs-nav')

      if (!el) return

      Sortable.create(el, {
        animation: 150,
        onEnd: ({ oldIndex, newIndex }) => {
          if (oldIndex === newIndex) return
          const routerTags = cloneDeep(state.routerTags)

          // 获取移动前当前选中的项
          const activeIndex = store.state.user.activeMenuKey
          const activeItem = state.routerTags[activeIndex]

          const currRow = routerTags.splice(oldIndex, 1)[0]
          routerTags.splice(newIndex, 0, currRow)
          store.commit('user/updateTags', routerTags)

          // 移动后，找到原来选中的项的新位置，更新 activeMenuKey
          if (activeItem) {
            const newActiveIndex = routerTags.findIndex(
              item => item.menuPath === activeItem.menuPath
            )
            if (newActiveIndex !== -1 && newActiveIndex !== activeIndex) {
              store.commit('user/setActiveMenuKey', newActiveIndex)
            }
          }
        }
      })
    }
    onMounted(() => {
      initBreadTags()
      nextTick(() => {
        initSortable()
      })
    })
    return {
      tagListRef,
      onTabEdit,
      onTabClick,
      onRightClick,
      store,
      activePath
    }
  }
}
</script>
<style lang="scss" scoped>
.tag-list {
  height: 35px;
  color: #b2b2bb !important;
  white-space: nowrap;
  transition: all 0.3s;
  :deep .portal-ant-tabs-bar {
    margin-bottom: 0;
  }
  :deep .portal-ant-tabs {
    overflow: hidden;
    flex: 1;
  }
  :deep .portal-ant-tabs-nav {
    overflow: hidden;
  }
  :deep .portal-ant-tabs-nav-wrap {
    overflow: hidden;
  }
}
</style>
<style lang="scss">
.tag-list {
  background: #fff;
  padding-left: 0;

  .portal-ant-tag {
    color: #b2b2bb;
    border: 1px solid #ccc;
    padding: 2px 3px;
    border-radius: 5px;
    display: inline-block;
    margin: 0 5px;
    line-height: normal;
    cursor: pointer;
    background: transparent;
    font-size: 12px;
    &.active {
      color: #333;
      .anticon-close {
        color: #333;
        margin-left: 3px;
      }
    }
  }

  .portal-ant-tabs-nav {
    margin-bottom: 0 !important;

    .portal-ant-tabs-tab {
      padding-left: 12px !important;
      padding-right: 12px !important;
      background: #f8f8f8 !important;
      border-bottom: none !important;
      border-radius: 4px 4px 0 0 !important;
      font-size: 12px !important;

      &.portal-ant-tabs-tab-active {
        background: #fff !important;
      }
    }

    .portal-ant-tabs-tab-remove {
      margin-left: 2px !important;
    }

    .portal-ant-tabs-nav-more {
      padding-top: 5px !important;
      padding-bottom: 5px !important;
      cursor: pointer;
    }

    .portal-ant-tabs-dropdown-menu-item-remove {
      margin-left: 4px;
    }
  }
}
</style>
